const COMMON = 'rgba(174, 181, 185, 0.5)';
const DARKLY = 'rgba(76, 82, 85, 0.4)';
const WHITE = '#FFFFFF';

const theme = {
  COMMON,
  DARKLY,
  WHITE,
  fonts: 'Montserrat, sans-serif',
  size: '44px',
};

export default theme;
